<input type="hidden" id="safari-cancel-button-indicator">
<button [id]="id" class="btn btn-ghost-secondary s_cancel" type="button">CANCEL</button>